import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./BlogListCard.css";

const BlogListCard = ({
  slug,
  category,
  featured,
  title,
  description,
  author,
  date,
  readTime,
  tags = [],
}) => {
  const [showAllTags, setShowAllTags] = useState(false);

  const visibleTags = showAllTags ? tags : tags.slice(0, 4);

  return (
    <Card className="blog_card">
      <div className="blog_card_head">
        {featured && <p className="blog_featured">Featured</p>}
        <p className="blog_category">{category}</p>
      </div>

      <h3 className="blog_title">{title}</h3>
      <p className="blog_description">{description}</p>

      <div className="blog_tags">
        {visibleTags.map((tag, index) => (
          <span key={index}>{tag}</span>
        ))}

        {tags.length > 4 && !showAllTags && (
          <span className="blog_more_link" onClick={() => setShowAllTags(true)}>
            +{tags.length - 4} more
          </span>
        )}
      </div>

      <div className="blog_meta">
        {author && <span className="blog_author">{author}</span>}
        {date && <span className="blog_date">{date}</span>}
        {readTime && <span className="blog_read_time">{readTime}</span>}
      </div>

      <Link to={`/blog/${slug}`} className="blog_btn">
        Read More
      </Link>
    </Card>
  );
};

export default BlogListCard;
